import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TitleStrategyService extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private translate: TranslateService,
  ) {
    super();
  }

  updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (title !== undefined) {
      this.translate
        .stream(title)
        .pipe()
        .subscribe((res) => {
          this.title.setTitle(`${res} - LiteDM`);
        });
    } else {
      this.title.setTitle(`LiteDM`);
    }
  }
}
